import * as getters from './getters';
import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingExperiences: false,
  },
  getters,
  actions,
  mutations: {
    'experiences/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
